export function alignmentToFlex(align) {
    switch (align) {
        case 'left':
            return 'flex-start';
        case 'center':
            return 'center';
        case 'right':
            return 'flex-end';
        default:
            return 'flex-start';
    }
}
//# sourceMappingURL=alignmentToFlex.js.map